// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading[data-v-600452eb]{cursor:wait !important}`, "",{"version":3,"sources":["webpack://./src/components/buttons/button/button.component.scoped.scss"],"names":[],"mappings":"AAAA,0BAA0B,sBAAsB","sourcesContent":[".loading[data-v-600452eb]{cursor:wait !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
